<div class="row mt-4">
  <div class="col-12">
    <h5 class="mb-0 mt-0" translate>SAFEGUARD_OVERRIDE</h5>
    <span class="font-italic small mb-2 d-inline-block" translate>SAFEGUARD_OVERRIDE_DESCRIPTION</span>
  </div>
</div>

@if (loaded) {
  @if (activeOverride) {
    <div class="row mt-2">
      <div class="col-12 col-md-3">
        <label class="font-weight-bold" translate>CREATED_BY</label>
        <div>{{ activeOverride.createdBy }}</div>
      </div>
      <div class="col-12 col-md-3">
        <label class="font-weight-bold" translate>REASON</label>
        <div>{{ activeOverride.reason }}</div>
      </div>
      <div class="col-12 col-md-3">
        <label class="font-weight-bold" translate>CREATED_AT</label>
        <div>{{ activeOverride.createdAt | date:'medium' }}</div>
      </div>
      <div class="col-12 col-md-3">
        <label class="font-weight-bold" translate>EXPIRES_AT</label>
        <div>
          {{ activeOverride.expiresAt | date:'medium' }}
          @if (activeOverride.consumed) {
            <span class="badge bg-secondary ms-1" translate>CONSUMED</span>
          } @else {
            <span class="badge bg-success ms-1" translate>ACTIVE</span>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="mt-2 mb-2 text-muted">
      {{ 'NO_ACTIVE_OVERRIDE' | translate }}
    </div>
  }

  <div class="row mt-3">
    <div class="col-12 col-md-6">
      <label class="form-label" translate>OVERRIDE_REASON</label>
      <textarea class="form-control" rows="2" [(ngModel)]="reason" [placeholder]="'OVERRIDE_REASON_PLACEHOLDER' | translate"></textarea>
    </div>
  </div>
  <button class="btn btn-warning mt-2" (click)="createOverride()" [disabled]="loading || !reason.trim()">
    {{ 'CREATE_OVERRIDE' | translate }}
    @if (loading) {
      <i class="fas fa-spinner fa-spin ms-1"></i>
    }
  </button>
}
